import { getAdminInfo } from '@apis/auth';
import {
  createContext,
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { Navigate } from 'react-router-dom';

export interface userInterface {
  email?: string;
}
export interface ContextProps<T> {
  user: T;
  setUser: Dispatch<SetStateAction<T>>;
}

export const AuthContext = createContext<ContextProps<userInterface>>({
  user: {},
  setUser: (val) => val,
});

export const AuthProvider: FunctionComponent<{ user: userInterface }> = ({
  user: adminUser,
  children,
}) => {
  const [userState, setUserState] = useState<userInterface>(adminUser);
  const { data, loading, error } = getAdminInfo();

  useEffect(() => {
    if (data) setUserState(data.data.admin_info);
  }, [data]);

  if (loading) return null;
  if (error) return <Navigate to="/login" />;

  return (
    <AuthContext.Provider value={{ user: userState, setUser: setUserState }}>
      {children}
    </AuthContext.Provider>
  );
};
